import { MediaQueries, Spacing } from 'UI'

export default {
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  seeMoreRow: {
    margin: Spacing(5, 0, 0, 0)
  },
  root: {
    padding: () => Spacing(4, 0),
    width: '100%'
  },
  view: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 40
  },
  [MediaQueries.mobile]: {
    view: {
      gap: 16
    }
  },
  [`${MediaQueries.tablet}`]: {
    view: {
      gap: 16
    }
  }
}
